import { LoadingButton } from '@mui/lab';
import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import api from '~/services/api';
import TokenService from '~/services/token';
import { storeState } from '~/store';
import { buildPdfBlobFromApiResponse, triggerPdfDownload } from '~/utils/downloadPdf';
import { getErrorMessage, logErrorWithContext } from '~/utils/errorHandler';

export default function ContractDownload() {
  const _navigate = useNavigate();
  const { contractHash } = useParams();
  const [searchParams] = useSearchParams();
  const organizationId = searchParams.get('org') ?? undefined;
  const [isLoading, setIsLoading] = useState(false);

  const downloadContract = async () => {
    if (!contractHash) return;

    try {
      setIsLoading(true);
      await TokenService.getClientCredencial();

      const getParams = organizationId ? { organization_id: organizationId } : undefined;

      const contractResponse = await api.v2?.get(`/contracts/${contractHash}`, { params: getParams });
      const contractId = contractResponse?.data?.data?.contract_id ?? contractHash;

      const response = await api.v2?.get(`/contracts/${contractHash}/download`, {
        params: getParams,
        responseType: 'arraybuffer'
      });

      const blob = buildPdfBlobFromApiResponse(response?.data);
      triggerPdfDownload(blob, `contrato_${contractId}.pdf`);
    } catch (error) {
      logErrorWithContext(error, 'contract_download', {
        contractHash,
        organizationId
      });
      const errorResponse = getErrorMessage(error, 'Não foi possível baixar o contrato. Tente novamente mais tarde.');
      storeState.addToast(errorResponse);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    downloadContract();
  }, [contractHash, organizationId]);

  return (
    <Box
      sx={{
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        paddingTop: '8rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        alignItems: 'center',
        justifyContent: 'flex-start',
        maxWidth: 520
      }}
    >
      <Typography variant="h1" fontSize={28} fontWeight="bold" textAlign="center">
        Download do Contrato
      </Typography>

      <Typography variant="h3" fontSize={24} fontWeight="bold" paddingTop="1rem" textAlign="center">
        O download do contrato será iniciado automaticamente em instantes. Caso o processo não comece, clique no botão
        abaixo para fazer o download manualmente.
      </Typography>

      <LoadingButton
        variant="contained"
        onClick={downloadContract}
        disabled={isLoading}
        sx={{ minWidth: '60%', marginTop: 2 }}
        loading={isLoading}
      >
        Baixar contrato
      </LoadingButton>
      <Typography variant="subtitle2" fontSize={20} textAlign="center" fontWeight="300">
        Se tiver alguma dúvida ou encontrar dificuldades, entre em contato com nossa equipe de suporte.
      </Typography>
    </Box>
  );
}
